<template>
  <transition name="agreement-fade">
    <div class="agreement-modal" v-if="visible" @click.self="$emit('close')">
      <div class="agreement-content">
        <div class="agreement-header">
          <h3>{{ title }}</h3>
          <span class="close-btn" @click="$emit('close')">×</span>
        </div>
        <div class="agreement-body">
          <div v-html="content"></div>
        </div>
        <div class="agreement-footer">
          <button class="agree-btn" @click="$emit('agree')">我已阅读并同意</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'AgreementModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'user'
    }
  },
  computed: {
    title() {
      return this.type === 'user' ? '用户协议' : '隐私政策'
    },
    content() {
      if (this.type === 'user') {
        return `
          <h4>一、服务条款的接受</h4>
          <p>欢迎使用智慧云行渠道服务。在使用本服务之前，请您仔细阅读本协议的全部内容。如果您不同意本协议的任何条款，请不要注册或使用本服务。</p>
          
          <h4>二、服务内容</h4>
          <p>1. 本平台为渠道人员提供订单推广、佣金结算等服务。</p>
          <p>2. 渠道人员需完成实名认证后方可使用相关服务。</p>
          <p>3. 平台有权根据业务发展需要调整服务内容。</p>
          
          <h4>三、用户注册与账户安全</h4>
          <p>1. 用户注册时应提供真实、准确、完整的个人信息。</p>
          <p>2. 用户应妥善保管账户信息，因账户泄露造成的损失由用户自行承担。</p>
          <p>3. 如发现账户被盗用，应立即通知平台。</p>
          
          <h4>四、用户行为规范</h4>
          <p>1. 用户不得利用本服务从事任何违法违规活动。</p>
          <p>2. 用户不得以任何方式干扰本服务的正常运行。</p>
          <p>3. 用户应遵守平台的各项规则和制度。</p>
          
          <h4>五、佣金结算</h4>
          <p>1. 佣金按照平台规定的比例和周期进行结算。</p>
          <p>2. 用户需绑定有效的收款账户方可提现。</p>
          <p>3. 平台有权对异常订单进行核查和处理。</p>
          
          <h4>六、免责声明</h4>
          <p>1. 因不可抗力导致的服务中断，平台不承担责任。</p>
          <p>2. 用户因自身原因导致的损失，平台不承担责任。</p>
          
          <h4>七、协议修改</h4>
          <p>平台有权根据需要修改本协议，修改后的协议将在平台公布。继续使用本服务即视为同意修改后的协议。</p>
          
          <p style="margin-top: 20px; color: #999;">最后更新日期：2024年1月1日</p>
        `
      } else {
        return `
          <h4>一、信息收集</h4>
          <p>我们收集的信息包括：</p>
          <p>1. <strong>身份信息</strong>：姓名、身份证号、手机号码等，用于实名认证。</p>
          <p>2. <strong>位置信息</strong>：用于推荐附近的工作机构和场站。</p>
          <p>3. <strong>设备信息</strong>：设备型号、操作系统等，用于优化服务体验。</p>
          
          <h4>二、信息使用</h4>
          <p>我们使用收集的信息用于：</p>
          <p>1. 提供、维护和改进我们的服务。</p>
          <p>2. 验证用户身份，保障账户安全。</p>
          <p>3. 进行佣金结算和财务管理。</p>
          <p>4. 向用户发送服务通知和营销信息（可选择退订）。</p>
          
          <h4>三、信息保护</h4>
          <p>1. 我们采用业界标准的安全技术保护您的信息。</p>
          <p>2. 我们对员工进行数据安全培训，限制信息访问权限。</p>
          <p>3. 我们不会向第三方出售您的个人信息。</p>
          
          <h4>四、信息共享</h4>
          <p>以下情况我们可能共享您的信息：</p>
          <p>1. 获得您的明确同意后。</p>
          <p>2. 根据法律法规要求或政府部门的要求。</p>
          <p>3. 与关联公司共享，用于提供更好的服务。</p>
          
          <h4>五、用户权利</h4>
          <p>您有权：</p>
          <p>1. 访问和更正您的个人信息。</p>
          <p>2. 删除您的账户和相关信息。</p>
          <p>3. 撤回您的授权同意。</p>
          
          <h4>六、Cookie使用</h4>
          <p>我们使用Cookie来改善用户体验，您可以通过浏览器设置管理Cookie。</p>
          
          <h4>七、未成年人保护</h4>
          <p>本服务仅面向18周岁以上的成年人。我们不会故意收集未成年人的个人信息。</p>
          
          <h4>八、联系我们</h4>
          <p>如有任何隐私相关问题，请联系客服：400-xxx-xxxx</p>
          
          <p style="margin-top: 20px; color: #999;">最后更新日期：2024年1月1日</p>
        `
      }
    }
  },
  watch: {
    visible(val) {
      document.body.style.overflow = val ? 'hidden' : ''
    }
  },
  beforeDestroy() {
    document.body.style.overflow = ''
  }
}
</script>

<style scoped>
.agreement-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.agreement-content {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}

.agreement-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;
}

.agreement-header h3 {
  margin: 0;
  font-size: 18px;
  color: #333;
  font-weight: 600;
}

.agreement-header .close-btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.2s ease, color 0.2s ease;
  -webkit-tap-highlight-color: transparent;
}

.agreement-header .close-btn:active {
  background: #f5f5f5;
  color: #666;
}

.agreement-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  -webkit-overflow-scrolling: touch;
  font-size: 14px;
  line-height: 1.8;
  color: #666;
}

.agreement-body >>> h4 {
  color: #333;
  font-size: 15px;
  margin: 20px 0 10px;
  font-weight: 600;
}

.agreement-body >>> h4:first-child {
  margin-top: 0;
}

.agreement-body >>> p {
  margin: 8px 0;
  text-align: justify;
}

.agreement-body >>> strong {
  color: #333;
}

.agreement-footer {
  padding: 16px 20px;
  border-top: 1px solid #eee;
  flex-shrink: 0;
}

.agreement-footer .agree-btn {
  width: 100%;
  height: 44px;
  background: linear-gradient(135deg, #2B77FF 0%, #1A5FD9 100%);
  color: #fff;
  border: none;
  border-radius: 22px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(43, 119, 255, 0.3);
  touch-action: manipulation;
  transition: opacity 0.2s ease, transform 0.1s ease;
}

.agreement-footer .agree-btn:active {
  opacity: 0.9;
  transform: scale(0.98);
}

.agreement-fade-enter-active,
.agreement-fade-leave-active {
  transition: opacity 0.3s ease;
}

.agreement-fade-enter-active .agreement-content,
.agreement-fade-leave-active .agreement-content {
  transition: transform 0.3s ease;
}

.agreement-fade-enter,
.agreement-fade-leave-to {
  opacity: 0;
}

.agreement-fade-enter .agreement-content,
.agreement-fade-leave-to .agreement-content {
  transform: scale(0.9) translateY(20px);
}
</style>
